/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable arrow-body-style */
import { useState, useEffect, useMemo } from 'react';
import { useNavigate, Link as RouterLink, Link } from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import { Delete } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import { Box, Button, Container, IconButton, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
import axiosInstance from '../../../utils/axios';
import Page from '../../../components/Page';
import Iconify from '../../../components/Iconify';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';

export default function Invoices() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const columns = useMemo(
    () => [
      {
        accessorKey: 'invoice_number',
        header: 'Order',
        size: 5,
        Cell: ({ row }) => (
          <>
            <div className="d-flex" style={{ alignItems: 'baseline' }}>
              <Typography variant="h6" gutterBottom>
                {row?.original?.invoice_number}
              </Typography>{' '}
              <Typography
                className="ms-2"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  navigate('/dashboard/viewbooking', { state: row.original });
                }}
              >
                {row?.original?.reservation_id}
              </Typography>
            </div>
          </>
        ),
      },
      {
        accessorKey: 'date',
        header: 'Date',
        size: 5,
      },
      {
        accessorKey: 'status',
        header: 'Status',
        size: 5,
      },
      {
        accessorKey: 'payment_method',
        header: 'Payment Method',
        size: 5,
      },
      {
        accessorKey: 'total',
        header: 'Total',
        size: 5,
      },
      // {
      //   accessorKey: 'status',
      //   header: 'Status',
      //   size: 10,
      //   Cell: ({ row }) =>
      //     row?.original?.status == 1 ? (
      // <Button
      //   fullWidth
      //   variant="contained"
      //   color="success"
      //   endIcon={<Iconify icon={'eva:checkmark-circle-2-fill'} />}
      //   onClick={() => {
      //     handleApproved(row?.original?.id);
      //   }}
      // >
      //   Active
      // </Button>
      //     ) : (
      //       <Button
      //         fullWidth
      //         variant="contained"
      //         color="error"
      //         endIcon={<Iconify icon={'eva:close-circle-fill'} />}
      //         onClick={() => {
      //           handleApproved(row?.original?.id);
      //         }}
      //       >
      //         InActive
      //       </Button>
      //     ),
      // },
    ],
    []
  );

  const [tableData, setTableData] = useState([]);

  async function AllUsers() {
    const data = await axiosInstance.get('invoice');
    console.log(data?.data?.data, 'invoices');
    setTableData(data?.data?.data);
  }

  useEffect(() => {
    AllUsers();
  }, []);

  return (
    <>
      <Page title="Invoices">
        <Container maxWidth="lg">
          <HeaderBreadcrumbs heading="Invoices" links={[{ name: '', href: '' }]} />
          <MaterialReactTable
            columns={columns}
            data={tableData}
            enableRowActions
            renderRowActions={({ row }) => (
              <Box
                sx={{
                  display: 'flex',
                  flexWrap: 'nowrap',
                  gap: '5px',
                  justifyContent: 'flex-center',
                }}
              >
                <Button
                  fullWidth
                  variant="contained"
                  color="success"
                  endIcon={<Iconify icon={'eva:checkmark-circle-2-fill'} />}
                  onClick={() => {
                    navigate('/dashboard/invoicesdetails', { state: row?.original });
                  }}
                >
                  Details
                </Button>
              </Box>
            )}
            positionActionsColumn="last"
          />
        </Container>
      </Page>
    </>
  );
}
